import { Flex } from 'antd'
import { DocumentControls } from "./DocumentControls"
import { Outlet } from "react-router-dom"

export const ReportRouterView = () =>
    <Flex style={{ width: '100%', alignSelf: 'flex-start' }} vertical>
        <DocumentControls/>
        <Outlet />
    </Flex>
